import React from "react";
import {Button, Col, Row,} from "reactstrap";
import {RequestReceived} from "../../container/broadcast/BroadcastAvailabilityRequests/Components";
import NoRequestReceived from "../NoRequestReceived";
import loading_white from "../../assets/gif/loading_white.gif";

const OneonOneRequests = (props) => {
    const {searchStatus, searchData, requestCount, requests} = props;
    let requestArray = [];

    if (searchData.length === 0) {
        //nothing searched from the user end so show unfiltered list
        if (requestCount > 0) {
            if (!searchStatus) {
                //there are request pending
                requestArray = requests;
            } else {
                return (
                    <NoRequestReceived
                        hideShare
                        shareList={props.shareList}
                        message="Sorry no results found"/>
                )
            }
        } else {
            //no request pending show empty screen
            return (
                <NoRequestReceived
                    shareList={props.shareList}
                    message="1-on-1 requests will appear here. Get sharing and let people know you are available"/>
            )
        }
    } else {
        //user has searched so lets show from the filtered list
        requestArray = searchData;
    }

    if(props.video){
        return(
            <div className="full-width list-of-request">
                {
                    requestArray.map(
                        (data, index) =>
                            data.status === 0 && (
                                <RequestReceived
                                    req_id={data.id}
                                    userName={data.username}
                                    userImage={data.profile_pic}
                                    user_id={data.user_id}
                                    userRequest={props.requestMessage}
                                    userRequestHourAgo={data.updated_at_human_readable}
                                    key={index}
                                    status={data.status}
                                    isFavourite={data.is_favourite}
                                    index={index}
                                    isChecked={props.isChecked}
                                    radioToggle={props.radioToggle}
                                    favorite={props.favoriteUserById}
                                    unFavorite={props.unFavoriteUserById}
                                    blockUser={props.blockUserById}
                                    removeRequest={props.removeUserRequestByReqId}
                                    acceptRequestData={props.broadcasterAcceptRequestData}
                                    video={props.video}
                                />
                            )
                    )
                }
            </div>
        )
    }

    return (
        <Row className="mx-0 full-width">
            {
                requestArray.map(
                    (data, index) =>
                        data.status === 0 && (
                            <RequestReceived
                                req_id={data.id}
                                userName={data.username}
                                userImage={data.profile_pic}
                                user_id={data.user_id}
                                userRequest={props.requestMessage}
                                userRequestHourAgo={data.updated_at_human_readable}
                                key={index}
                                status={data.status}
                                isFavourite={data.is_favourite}
                                index={index}
                                isChecked={props.isChecked}
                                radioToggle={props.radioToggle}
                                favorite={props.favoriteUserById}
                                unFavorite={props.unFavoriteUserById}
                                blockUser={props.blockUserById}
                                removeRequest={props.removeUserRequestByReqId}
                                acceptRequestData={props.broadcasterAcceptRequestData}
                            />
                        )
                )
            }
            {
                requestArray.length > 0 && (
                    <React.Fragment>
                        <Row className="mt-5 mb-5 mx-2 full-width">
                            <Col md="12" sm="12" className="text-center">
                                <Button
                                    color="primary"
                                    {...(props.availability.isFetching
                                        ? {style: {padding: "1% 10%"}}
                                        : {className: "px-5"})}
                                    onClick={() =>
                                        props.submitBroadcasterAcceptRequest("onetoone")
                                    }
                                    disabled={!props.isChecked}
                                >
                                    {props.availability.isFetching ? (
                                        <img
                                            src={loading_white}
                                            alt={"Loading"}
                                            width={26}
                                            height={26}
                                        />
                                    ) : (
                                        "ACCEPT 1-ON-1 REQUEST"
                                    )}
                                </Button>
                            </Col>
                        </Row>

                    </React.Fragment>
                )
            }
        </Row>
    );
};

export default OneonOneRequests;